/**
 * Eigenes Konto — v2, Guard 'admin'.
 *
 *   PUT /v2/admin/me/password — eigenes Passwort ändern
 *
 * Bis 18.09.2026 gab es diesen Endpunkt nicht: das Formular unter
 * Einstellungen → Sicherheit war ein Mockup ohne State und ohne Route
 * (gemeldet als „Passwort ändern geht nicht mehr").
 */
import { apiV2 } from './api';

export interface PasswordChangeResult {
  changed: boolean;
  /** Anzahl beendeter anderer Sitzungen (die laufende bleibt bestehen). */
  sessions_revoked: number;
}

/** Feldbezogener Fehler aus dem v2-Envelope. */
export interface V2FieldError {
  code?: string;
  message: string;
  field?: string;
}

export const v2Account = {
  /**
   * Ändert das eigene Passwort. Wirft bei 422 ein Objekt mit den
   * feldbezogenen Fehlern des Backends, damit die Oberfläche sie direkt am
   * Feld anzeigen kann statt nur „Request failed with status code 422".
   */
  updatePassword: async (payload: {
    current_password: string;
    password: string;
    password_confirmation: string;
  }): Promise<PasswordChangeResult> => {
    const res = await apiV2.put<{ data: PasswordChangeResult }>('/admin/me/password', payload);
    return res.data.data;
  },
};

/**
 * Zieht die lesbaren Fehlermeldungen aus einer fehlgeschlagenen v2-Antwort.
 * Deckt beide Formate ab: den v2-Envelope (`errors: [{ message, field }]`)
 * und Laravels Validierungsformat (`errors: { feld: [meldung] }`).
 */
export function v2ErrorMessages(err: unknown): string[] {
  const data = (err as { response?: { data?: unknown } })?.response?.data as
    | { errors?: unknown; message?: string }
    | undefined;
  if (!data) return [];

  const errors = data.errors;
  if (Array.isArray(errors)) {
    return (errors as V2FieldError[]).map(e => e.message).filter(Boolean);
  }
  if (errors && typeof errors === 'object') {
    return Object.values(errors as Record<string, string[] | string>)
      .flatMap(v => (Array.isArray(v) ? v : [v]))
      .filter(Boolean) as string[];
  }
  return data.message ? [data.message] : [];
}
